
import * as getters from './getters'
import mutations from './mutations'
import * as actions from './actions'
const userInfoStr = YJ_REGION_STORAGE.getItem('userInfo')
const userInfo = userInfoStr ? JSON.parse(userInfoStr) : {}
const state = {
  loading: false,
  currentPage: 1,
  headerStatus: true,
  roleId: '',
  roleCode: '',
}

if (userInfo.roles && userInfo.roles.length) {
  state.roleId = userInfo.roles[0].id
  state.roleCode = userInfo.roles[0].roleCode
}

export default {
  state,
  getters,
  mutations,
  actions
}





// WEBPACK FOOTER //
// ./src/vuex/modules/app/index.js